const A = "https://customer-assets-eiarnc6j.emergentagent.net/job_calm-hub-7/artifacts";

// Founder-supplied editorial photography (replaces all generated imagery)
export const IMAGES = {
  founder: `${A}/eid89433_Screenshot%202026-09-17%20at%204.53.09%E2%80%AFPM.png`,
  hero: `${A}/ayyo9gpq_34.png`, // B&W double-exposure silhouette
  regulate: `${A}/g93zuny4_36.png`, // B&W resting by water
  rewire: `${A}/jc8hlnwd_27.png`, // butterfly shadow on hand
  radiate: `${A}/jce7k7sb_35.png`, // warm sunrise shoreline
  lips: `${A}/h4wzdgqu_37.png`,
};

export const STORE = {
  appStore: "https://apps.apple.com/us/app/radiate-meditation-app/id6757485959",
  googlePlay:
    "https://play.google.com/store/apps/details?id=com.selffm.app&hl=en_US",
};

// The free meditation gifted on this page
export const MEDITATION = {
  title: "Tap into Lucky Energy",
  meta: "Morning · 8 min",
  audio: "/tap-into-lucky-energy.m4a",
  cover: "/lucky-energy-cover.jpeg",
};

// Real in-app screens (uploaded by the founder)
export const APP_SHOTS = [
  { src: "/app-shots/IMG_4494.webp", label: "For you", caption: "Daily recommendations & prompts" },
  { src: "/app-shots/IMG_4495.webp", label: "Discover", caption: "Manifest · Walking · Sleep · Reset" },
  { src: "/app-shots/IMG_4497.webp", label: "Profile", caption: "Streaks, stats & achievements" },
];

// The Method — copy from radiateapp.com
export const METHOD = [
  {
    n: "I",
    title: "Regulate",
    body: "Guided breathwork and somatic audio bring your nervous system back to a felt sense of safety.",
    image: IMAGES.regulate,
  },
  {
    n: "II",
    title: "Rewire",
    body: "Subconscious reprogramming helps you release old beliefs and install new ones that actually hold.",
    image: IMAGES.rewire,
  },
  {
    n: "III",
    title: "Radiate",
    body: "Confidence and magnetism that come from a nervous system that finally feels safe enough to expand.",
    image: IMAGES.radiate,
  },
];

export const TESTIMONIALS = [
  {
    title: "The Most Important Part of My Day",
    body: "This app has changed my life! I've always been intimidated by meditations and these have been an amazing addition to my day. If you have 10 minutes, you have time for meditations.",
    name: "Emdurs",
  },
  {
    title: "Helps Me Regulate My Nervous System",
    body: "They really work — I feel grounded, focused and intentional about my day and life after listening. I love the daily prompts for journaling too.",
    name: "Allylyon",
  },
  {
    title: "Created with Heart, Designed for You",
    body: "The aesthetic is beautiful while still being simple and easy to navigate, which creates such a calm and intentional experience. Each meditation feels thoughtfully written.",
    name: "Lexie23",
  },
  {
    title: "The BEST Meditation App I've Ever Had",
    body: "Radiate has been part of my morning routine for years. I love the themes, the energy, and the life-giving messages. The lengths fit seamlessly into your life.",
    name: "sarahh.ortega",
  },
  {
    title: "My Daily Dose of Calm",
    body: "I love turning these on while doing my skincare or winding down. The experience is simple and calming, and the streaks and achievements keep me showing up for myself.",
    name: "cwaschek",
  },
];
